/* Compagnons de Cœur — guide des tailles et dimensions de chaque fiche (mission 2026-10-08-17).
   Le lien (snippet cdc-guide-taille-lien) porte la source des données (section cdc-guide-taille : métaobjets guide_taille de la
   fiche) et l'identifiant du produit. Rien n'est construit avant
   l'ouverture : au premier clic, les données sont lues (une fois), puis la fenêtre est créée. Élément <dialog> modal : Échap,
   croix et clic hors de la fenêtre la ferment ; le focus reste dedans et revient au lien (ou à l'Atelier) à la fermeture.
   L'Atelier (iframe) l'ouvre aussi, par cdc-atelier-embed.js : window.CDCGuideTaille.open({ coupe, onClose }). */
(function () {
  'use strict';
  if (window.CDCGuideTaille) return;
  var cache = {};
  var dialog = null, opener = null, onClose = null, link = null, data = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function load(src) {
    // La section renvoie du HTML qui contient un bloc JSON ; un fichier .json est lu tel quel.
    if (!cache[src]) cache[src] = fetch(src, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) {
        try { return JSON.parse(text); } catch (_) {}
        var node = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-cdc-gt-json]');
        if (!node) throw new Error('json');
        return JSON.parse(node.textContent);
      })
      .catch(function (e) { delete cache[src]; throw e; });
    return cache[src];
  }

  /* Schémas « comment mesurer » : vêtement posé à plat, dessinés ici (aucune image). A = demi-largeur de poitrine, B = longueur, C = manche. */
  var ARROW = 'stroke="#A9563E" stroke-width="2.2" marker-start="url(#cdc-gt-m)" marker-end="url(#cdc-gt-m)"';
  var DEFS = '<defs><marker id="cdc-gt-m" viewBox="0 0 10 10" refX="5" refY="5" markerWidth="5" markerHeight="5" orient="auto-start-reverse"><path d="M0 0L10 5L0 10z" fill="#A9563E"/></marker></defs>';
  var LBL = 'font-family="Nunito Sans,system-ui,sans-serif" font-size="15" font-weight="800" fill="#A9563E"';
  var SCHEMAS = {
    tshirt: '<svg viewBox="0 0 240 230" role="img" aria-labelledby="cdc-gt-svgt"><title id="cdc-gt-svgt">T-shirt posé à plat : A, demi-largeur de poitrine d’une couture de côté à l’autre, sous les manches ; B, longueur du haut de l’épaule au bas ; C, longueur de la manche.</title>' + DEFS +
      '<path d="M84 22 Q120 44 156 22 L206 46 L224 98 L188 110 L182 92 L182 212 L58 212 L58 92 L52 110 L16 98 L34 46 Z" fill="#F5EFE6" stroke="#5d7e5e" stroke-width="2" stroke-linejoin="round"/>' +
      '<line x1="62" y1="104" x2="178" y2="104" ' + ARROW + '/><text x="120" y="98" text-anchor="middle" ' + LBL + '>A</text>' +
      '<line x1="96" y1="30" x2="96" y2="208" ' + ARROW + '/><text x="104" y="160" ' + LBL + '>B</text>' +
      '<line x1="160" y1="26" x2="210" y2="94" ' + ARROW + '/><text x="196" y="56" ' + LBL + '>C</text></svg>',
    sweat: '<svg viewBox="0 0 240 250" role="img" aria-labelledby="cdc-gt-svgs"><title id="cdc-gt-svgs">Sweat à capuche posé à plat : A, demi-largeur de poitrine sous les manches ; B, longueur du corps, du haut de l’épaule au bas ; C, longueur de la manche.</title>' + DEFS +
      '<path d="M88 30 Q92 4 120 4 Q148 4 152 30 Q120 46 88 30Z" fill="#EDE4D6" stroke="#5d7e5e" stroke-width="2"/>' +
      '<path d="M86 30 Q120 48 154 30 L200 46 L232 214 L204 220 L182 96 L182 232 L58 232 L58 96 L36 220 L8 214 L40 46 Z" fill="#F5EFE6" stroke="#5d7e5e" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M84 176 L156 176 L166 222 L74 222 Z" fill="none" stroke="#5d7e5e" stroke-width="1.4" stroke-dasharray="4 3"/>' +
      '<line x1="62" y1="100" x2="178" y2="100" ' + ARROW + '/><text x="120" y="94" text-anchor="middle" ' + LBL + '>A</text>' +
      '<line x1="98" y1="38" x2="98" y2="228" ' + ARROW + '/><text x="106" y="150" ' + LBL + '>B</text>' +
      '<line x1="160" y1="34" x2="214" y2="214" ' + ARROW + '/><text x="206" y="120" ' + LBL + '>C</text></svg>'
  };

  // Métaobjet { titre, lien, contenu } ou famille déjà à plat.
  function famille(x) { if (!x || !x.contenu) return x; var f = {}, k; for (k in x.contenu) f[k] = x.contenu[k]; f.titre = x.titre; f.lien = x.lien; return f; }
  var BIENTOT = 'bientôt disponible';
  function cell(v) { return v === BIENTOT ? '<span class="cdc-gt__soon">' + esc(v) + '</span>' : esc(v); }
  function table(caption, head, rows) {
    return '<div class="cdc-gt__scroll" role="region" tabindex="0" aria-label="' + esc(caption) + '"><table class="cdc-gt__table"><caption>' + esc(caption) + '</caption><thead><tr>' +
      head.map(function (h, i) { return '<th scope="col"' + (i ? '' : ' class="cdc-gt__first"') + '>' + esc(h) + '</th>'; }).join('') + '</tr></thead><tbody>' +
      rows.map(function (r) { return '<tr><th scope="row">' + esc(r[0]) + '</th>' + r.slice(1).map(function (v) { return '<td>' + cell(v) + '</td>'; }).join('') + '</tr>'; }).join('') +
      '</tbody></table></div>';
  }
  // Les tailles en lignes : 4 colonnes au plus, lisibles à 390 px sans défilement de la page.
  function coupeHtml(f, c, coeur, showZones) {
    var short = c.lignes.map(function (l) { var m = /\(([A-C])\)$/.exec(l.libelle); return m ? m[1] + ' · ' + l.libelle.replace(/\s*\([A-C]\)$/, '') : l.libelle; });
    var html = table('Mesures du ' + c.nom.toLowerCase() + ', en cm', ['Taille'].concat(short), c.colonnes.map(function (s, i) { return [s].concat(c.lignes.map(function (l) { return l.valeurs[i]; })); }));
    html += '<p class="cdc-gt__note">' + esc(c.note) + '</p>';
    var zones = showZones === false ? [] : c.zones.filter(function (zr) { return coeur !== false || !/cœur/.test(zr.libelle); });
    if (zones.length) {
      html += '<h3 class="cdc-gt__h3">Taille du motif imprimé</h3>' + table('Taille maximale du motif, en cm (largeur × hauteur)', ['Taille'].concat(zones.map(function (zr) { return zr.libelle.replace(/, jusqu’à$/, '').replace(/^Grand motif /, '').replace(/^Petit motif /, ''); })),
        c.colonnes.map(function (s, i) { return [s].concat(zones.map(function (zr) { return zr.valeurs[i]; })); }));
      if (f.motif) html += '<p class="cdc-gt__note">' + esc(f.motif) + '</p>';
    }
    return html;
  }
  // Onglets : une coupe par onglet ; sur une fiche à plusieurs vêtements (motif), les coupes de chaque famille, nommées comme l'option.
  function body(fams, opts, coupe) {
    var html = '', first = fams[0];
    if (first.type === 'textile') {
      var items = [];
      if (opts.coupes && typeof opts.coupes[0] === 'object') opts.coupes.forEach(function (o) {
        var f = fams.filter(function (x) { return x.cle === o.famille; })[0], c = f && f.coupes.filter(function (y) { return y.cle === o.cle; })[0];
        if (c) items.push({ f: f, c: c, cle: o.libelle });
      });
      else fams.forEach(function (f) { f.coupes.forEach(function (c) { if (!opts.coupes || opts.coupes.indexOf(c.cle) !== -1) items.push({ f: f, c: c, cle: c.cle }); }); });
      var current = items.filter(function (it) { return it.cle === coupe; })[0] || items[0];
      if (items.length > 1) html += '<div class="cdc-gt__tabs" role="group" aria-label="Modèle">' + items.map(function (it) {
        return '<button type="button" data-cdc-gt-coupe="' + esc(it.cle) + '" aria-pressed="' + (it === current) + '">' + esc(it.cle) + '</button>'; }).join('') + '</div>';
      html += items.map(function (it) {
        return '<section class="cdc-gt__coupe" data-cdc-gt-panel="' + esc(it.cle) + '"' + (it === current ? '' : ' hidden') + '>' +
          '<div class="cdc-gt__how">' + (SCHEMAS[it.f.schema] || '') + '<p>' + esc(it.f.mesurer) + '</p></div>' + coupeHtml(it.f, it.c, opts.coeur, opts.zones) +
          (it.f.conseil ? '<p class="cdc-gt__tip">' + esc(it.f.conseil) + '</p>' : '') + '</section>'; }).join('');
    } else {
      var f = first;
      // Objets : une colonne par format (3 au plus), le texte passe à la ligne.
      if (f.tableau) html += table(f.titre + ', par format', ['Format'].concat(f.tableau.colonnes), f.tableau.lignes.map(function (l) { return [l.libelle].concat(l.valeurs); }));
      if (f.points && f.points.length) html += '<dl class="cdc-gt__points">' + f.points.map(function (pt) { return '<div><dt>' + esc(pt.libelle) + '</dt><dd>' + cell(pt.valeur) + '</dd></div>'; }).join('') + '</dl>';
    }
    return html;
  }

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'cdc-gt';
    dialog.setAttribute('aria-labelledby', 'cdc-gt-title');
    dialog.innerHTML = '<div class="cdc-gt__inner"><div class="cdc-gt__head"><h2 id="cdc-gt-title" class="cdc-gt__title"></h2>' +
      '<button type="button" class="cdc-gt__close" data-cdc-gt-close aria-label="Fermer"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button></div>' +
      '<div class="cdc-gt__body" data-cdc-gt-body></div></div>';
    document.body.appendChild(dialog);
    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-cdc-gt-close]')) { close(); return; }
      var tab = e.target.closest('[data-cdc-gt-coupe]');
      if (tab) { select(tab.getAttribute('data-cdc-gt-coupe')); return; }
      // Clic hors de la fenêtre : le clic tombe sur le <dialog> lui-même (son fond), en dehors du cadre intérieur.
      if (e.target === dialog) { var r = dialog.querySelector('.cdc-gt__inner').getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(); }
    });
    dialog.addEventListener('close', restore);
    // Le focus reste dans la fenêtre : Tab et Maj+Tab tournent entre ses éléments (la croix au moins).
    dialog.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(dialog.querySelectorAll('button,[href],[tabindex]:not([tabindex="-1"])'), function (el) { return !el.closest('[hidden]') && el.getClientRects().length; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });
  }
  function select(cle) {
    dialog.querySelectorAll('[data-cdc-gt-coupe]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cdc-gt-coupe') === cle)); });
    dialog.querySelectorAll('[data-cdc-gt-panel]').forEach(function (s) { s.hidden = s.getAttribute('data-cdc-gt-panel') !== cle; });
  }
  function close() { if (dialog && dialog.open) dialog.close(); }
  function restore() {
    document.documentElement.classList.remove('cdc-gt-lock');
    var cb = onClose, el = opener; onClose = null; opener = null;
    if (cb) { try { cb(); } catch (_) {} }
    else if (el && el.focus) el.focus();
  }

  function open(options) {
    options = options || {};
    link = link || document.querySelector('[data-cdc-gt-src]');
    if (!link) return false;
    opener = options.opener || link;
    onClose = typeof options.onClose === 'function' ? options.onClose : null;
    var src = link.getAttribute('data-cdc-gt-src'), id = link.getAttribute('data-cdc-gt-product');
    link.setAttribute('aria-busy', 'true');
    load(src).then(function (json) {
      data = json;
      var p = json.produits && json.produits[id];
      var keys = p ? (p.familles || [p.famille]) : [];
      var fams = keys.map(function (k) { var f = famille(json.familles[k]); if (f) f.cle = k; return f; }).filter(Boolean);
      if (!fams.length) throw new Error('famille');
      var opts = p.options || { coupes: p.coupes, coeur: p.coeur };
      var coupe = options.coupe;
      var from = link.getAttribute('data-cdc-gt-coupe-from');
      if (!coupe && from) { var checked = document.querySelector('input[name="options[' + from.replace(/["\\]/g, '') + ']"]:checked'); if (checked) coupe = checked.value; }
      if (!dialog) build();
      dialog.querySelector('#cdc-gt-title').textContent = fams.length > 1 ? 'Guide des tailles' : fams[0].titre;
      dialog.querySelector('[data-cdc-gt-body]').innerHTML = body(fams, opts || {}, coupe);
      document.documentElement.classList.add('cdc-gt-lock');
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('[data-cdc-gt-body]').scrollTop = 0;
      dialog.querySelector('[data-cdc-gt-close]').focus();
    }).catch(function () {
      // Données illisibles (réseau) : la fenêtre s'ouvre quand même avec un message, sans quitter la fiche.
      if (!dialog) build();
      dialog.querySelector('#cdc-gt-title').textContent = link.textContent.trim() || 'Guide des tailles';
      dialog.querySelector('[data-cdc-gt-body]').innerHTML = '<p class="cdc-gt__note">Le guide n’a pas pu s’afficher. Vérifiez votre connexion, puis réessayez.</p>';
      document.documentElement.classList.add('cdc-gt-lock');
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('[data-cdc-gt-close]').focus();
    }).then(function () { link.removeAttribute('aria-busy'); });
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cdc-gt-src]');
    if (!a) return;
    e.preventDefault();
    link = a;
    open({ opener: a });
  });
  window.CDCGuideTaille = { open: open, close: close };
})();
